import {
  Create,
  PasswordInput,
  ReferenceInput,
  SelectInput,
  SimpleFormConfigurable,
  TextInput,
} from "react-admin";

export const BankerCreate = () => {
  return (
    <Create>
      <SimpleFormConfigurable>
        <ReferenceInput source="bank" reference="banks">
          <SelectInput
            optionValue="sBank"
            optionText="sBankName"
            label="Bank"
            defaultValue="ircceo"
            variant="outlined"
          />
        </ReferenceInput>
        <TextInput variant="outlined" source="sFname" label="First Name" />
        <TextInput variant="outlined" source="sLname" label="Last Name" />
        <TextInput variant="outlined" source="sEmail" label="Email" />
        <TextInput variant="outlined" source="sMobilePhone" label="Mobile" />
        <PasswordInput variant="outlined" source="password" label="Password" />
      </SimpleFormConfigurable>
    </Create>
  );
};

export default BankerCreate;
